import * as React from "react";
import type { SVGProps } from "react";
const SvgConvert = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M62.028 7.189a5.217 5.217 0 0 0-5.217-5.217H7.19a5.217 5.217 0 0 0-5.217 5.217V56.81a5.217 5.217 0 0 0 5.217 5.217H56.81a5.217 5.217 0 0 0 5.217-5.217V7.19ZM56.81-.001A7.189 7.189 0 0 1 64 7.19V56.81A7.189 7.189 0 0 1 56.811 64H7.19a7.189 7.189 0 0 1-7.19-7.189V7.19a7.189 7.189 0 0 1 7.19-7.19H56.81Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M10.71 11.686 7.505 48.31a4.596 4.596 0 0 0 4.178 4.978l36.624 3.205a4.595 4.595 0 0 0 4.978-4.178l3.205-36.624a4.595 4.595 0 0 0-4.178-4.978L15.688 7.509a4.595 4.595 0 0 0-4.978 4.177Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M8.488 48.396a3.61 3.61 0 0 0 3.28 3.91l36.625 3.204a3.61 3.61 0 0 0 3.91-3.28l3.204-36.625a3.61 3.61 0 0 0-3.28-3.91L15.601 8.49a3.61 3.61 0 0 0-3.91 3.28L8.488 48.397Zm3.109 5.875a5.581 5.581 0 0 1-5.074-6.047L9.727 11.6a5.582 5.582 0 0 1 6.047-5.074L52.398 9.73a5.582 5.582 0 0 1 5.074 6.047l-3.204 36.624a5.582 5.582 0 0 1-6.047 5.074L11.597 54.27Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M20.158 8.084 6.066 38.304a4.17 4.17 0 0 0 2.016 5.541l30.22 14.092a4.17 4.17 0 0 0 5.541-2.017L57.935 25.7a4.17 4.17 0 0 0-2.017-5.54L25.699 6.066a4.17 4.17 0 0 0-5.54 2.017Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M6.96 38.72a3.183 3.183 0 0 0 1.54 4.231l30.22 14.092a3.183 3.183 0 0 0 4.23-1.54l14.092-30.22a3.183 3.183 0 0 0-1.54-4.23L25.283 6.96a3.183 3.183 0 0 0-4.23 1.54L6.96 38.72Zm.707 6.019a5.155 5.155 0 0 1-2.494-6.852l14.092-30.22a5.155 5.155 0 0 1 6.85-2.493l30.221 14.092a5.155 5.155 0 0 1 2.494 6.85l-14.092 30.22a5.155 5.155 0 0 1-6.851 2.494L7.667 44.74Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M29.194 6.736 6.737 29.193a3.97 3.97 0 0 0 0 5.614l22.457 22.457a3.97 3.97 0 0 0 5.614 0l22.457-22.457a3.97 3.97 0 0 0 0-5.614L34.808 6.736a3.97 3.97 0 0 0-5.614 0Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M7.433 29.89a2.984 2.984 0 0 0 0 4.22L29.89 56.566a2.984 2.984 0 0 0 4.22 0L56.566 34.11a2.984 2.984 0 0 0 0-4.22L34.11 7.434a2.984 2.984 0 0 0-4.22 0L7.433 29.89ZM6.04 35.504a4.956 4.956 0 0 1 0-7.008L28.496 6.039a4.956 4.956 0 0 1 7.008 0l22.457 22.457a4.956 4.956 0 0 1 0 7.008L35.504 57.961a4.956 4.956 0 0 1-7.008 0L6.039 35.504Z"
      clipRule="evenodd"
    />
    <path
      fill="#26A3DD"
      d="M40.964 23.219a1.061 1.061 0 0 0-1.155-.243L20.823 30.49c-.399.156-.69.555-.669.997 0 .443.292.847.69.998l7.892 2.978 2.977 7.89c.157.421.556.691.998.691.442 0 .82-.264.998-.669L41.2 24.368c.156-.4.043-.847-.243-1.155l.006.006Z"
    />
  </svg>
);
export default SvgConvert;
